import { AbilityActions, AbilitySubjects } from '../constants';

export function accountOwnerRoleAccessGenerator(
    can: (actions: string | string[], subjects: string | string[]) => void
): void {
    can(AbilityActions.establish, AbilitySubjects.socketConnection);
    can(AbilityActions.use, AbilitySubjects.notificationCenter);

    can(
        [
            AbilityActions.create,
            AbilityActions.edit,
            AbilityActions.delete,
            AbilityActions.change,
        ],
        [AbilitySubjects.admin, AbilitySubjects.adminWithExternDamageReport]
    );
    can([AbilityActions.edit, AbilityActions.change], AbilitySubjects.accountOwner);
    can([AbilityActions.create, AbilityActions.edit], AbilitySubjects.customerRoleGroup);
    can(AbilityActions.edit, AbilitySubjects.userManagementCardsWithBranches);

    can(AbilityActions.see, [
        AbilitySubjects.notificationNewMessageCustomerAdviserForm,
        AbilitySubjects.userManagement,
    ]);
}
